import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(auth)/components/AuthHeader.tsx");
